import { useFetchPageAnalyticsForFilter } from './useFetchPageAnalyticsForFilter';
import { useGetQueryValues } from '~/presentation/reports/query/hooks';
import { usePageAnalyticFilterStore } from '~/modules/page-analytic';
import { useReportPageTitleStore } from '~/modules/report-analytic';
import { EReportParamKeys } from '~/modules/report-analytic/types';
import { EFilterField } from '~/presentation/reports/common/type';
import { useReportDateTime } from '../../SelectDate/hooks';
import { useSearchParams } from '@remix-run/react';
import { useEffect } from 'react';

interface UsePageAnalyticsMetadataProps {
  enabled?: boolean;
}

export const usePageAnalyticsMetadata = ({
  enabled = true,
}: UsePageAnalyticsMetadataProps = {}) => {
  const mode = usePageAnalyticFilterStore((state) => state.analyticMode);
  const setPageTile = useReportPageTitleStore((state) => state.setPageTitle);

  const [searchParams] = useSearchParams();

  const [campaignIdValue, campaignGroupIdValue] = useGetQueryValues({
    fields: [EFilterField.SINGLE_CAMPAIGN, EFilterField.GROUP_CAMPAIGN],
  });
  const { currentDates } = useReportDateTime({
    hasCampaignFilter: !!campaignIdValue || !!campaignGroupIdValue,
  });
  const { data, isLoading } = useFetchPageAnalyticsForFilter({ currentDates, mode, enabled });

  const locationPath = searchParams.get(EReportParamKeys.PATH);

  const updatePageTile = () => {
    if (!locationPath) return;
    const pageTitle = data?.find((item) => item.locationPath === locationPath)?.pageTitle;

    if (!pageTitle) return;
    setPageTile(pageTitle);
  };

  useEffect(() => {
    updatePageTile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return {
    data,
    isLoading,
  };
};
